import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { formatPrice } from '@vy/services';
import React, { Suspense } from 'react';
import { useGetYtdBilledRevenue } from '../../../../../../../../hooks/requests/use-get-ytd-billed-revenue';
import { CURRENCIES } from '@vy/types';

type FinancialInsightsSectionProps = {
  mrr?: number;
  arr?: number;
  customerId: string;
};

export const FinancialInsightsSection: React.FC<FinancialInsightsSectionProps> = ({
  mrr = 0,
  arr = 0,
  customerId,
}) => {
  const currency = CURRENCIES.Usd;
  const { data: ytdData } = useGetYtdBilledRevenue(customerId);

  return (
    <Suspense fallback={<FinancialInsightsLoading />}>
      <Stack spacing={1}>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
            alignItems: "center"
          }}>
          <VyIcon icon="LightBulb" />
          <Typography
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              color: "#2D3949"
            }}>
            Financial Insights
          </Typography>
        </Box>

        <Stack spacing={2}>
          <Stack direction="row" spacing={4}>
            <Stack>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#7E8796"
                }}>
                MRR
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 400,
                  color: "rgba(13, 27, 39, 0.87)"
                }}>
                {formatPrice(mrr, currency)}
              </Typography>
            </Stack>
            <Stack>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#7E8796"
                }}>
                ARR
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 400,
                  color: "rgba(13, 27, 39, 0.87)"
                }}>
                {formatPrice(arr, currency)}
              </Typography>
            </Stack>
          </Stack>
          <Stack>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 500,
                color: "#7E8796"
              }}>
              Billed YTD
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 400,
                color: "rgba(13, 27, 39, 0.87)"
              }}>
              {formatPrice(ytdData?.ytdBilledRevenue ?? 0, currency)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Suspense>
  );
};

const FinancialInsightsLoading: React.FC = () => {
  return (
    <>
      <Stack spacing={1}>
        <Stack direction="row" spacing={4}>
          <Stack>
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Stack>

          <Stack>
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Stack>
        </Stack>
        <Stack>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={100} height={20} />
        </Stack>
      </Stack>
    </>
  );
};
